import type { EmptyProps } from 'antd';

export const EMPTY_STYLES: EmptyProps['styles'] = {
  image: { height: 'auto' },
  root: {
    height: '500px',
    paddingTop: 50
  }
};
